import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const COLS = [
  {
    title: "Engineering Architecture",
    links: [
      { label: "Custody, Authority, Receipts", to: "/engineering-architecture" },
      { label: "Control Decision Envelope", to: "/engineering-architecture" },
      { label: "Governed handoff", to: "/engineering-architecture" },
    ],
  },
  {
    title: "Studio",
    links: [
      { label: "Cierge Studio", to: "/cierge-studio" },
      { label: "Sectors", to: "/sectors" },
      { label: "Evidence", to: "/evidence" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/company" },
      { label: "Contact", to: "/company#contact" },
      { label: "Technical appendix", to: "/technical-appendix" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="no-print border-t border-ink/15 bg-ink text-stone" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-24">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="font-serif text-2xl tracking-tight">KATLAS</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-stone/50">
                Technology
              </span>
            </div>
            <p className="mt-6 max-w-sm font-serif text-xl italic leading-snug text-stone/80">
              Custody controls the evidence. Authority governs the action.
              Receipts prove what happened.
            </p>
            <Link
              to="/company#contact"
              data-testid="footer-cta"
              className="group mt-8 inline-flex items-center gap-2 border border-stone/30 px-5 py-3 font-sans text-sm text-stone transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              Bring us a journey
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.75} />
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-7 md:grid-cols-3">
            {COLS.map((col) => (
              <div key={col.title}>
                <h4 className="font-mono text-[11px] uppercase tracking-[0.24em] text-stone/50">
                  {col.title}
                </h4>
                <ul className="mt-4 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        className="font-sans text-sm text-stone/80 transition-colors hover:text-stone"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-stone/15 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-xs text-stone/45">
            KATLAS Technology → KATLAS engineering architecture → Cierge Studio → Journey Storybooks
          </p>
          <p className="font-mono text-xs text-stone/45">
            © {new Date().getFullYear()} KATLAS Technology · Baseline v1.1
          </p>
        </div>
      </div>
    </footer>
  );
}
